import {
  ApartmentOutlined,
  ClockCircleOutlined,
  ColumnWidthOutlined,
  ExperimentFilled,
  WarningFilled,
} from '@ant-design/icons'
import SickFace from '../../../assets/CustomIcons/sick_face_blue.png'
import React from 'react'

export const PayrollIcon = ({ name }) => {
  const trimmed = name?.toLowerCase()?.trim() || ''

  if (trimmed.includes('gallon')) return <ExperimentFilled />
  if (trimmed.includes('mile')) return <ColumnWidthOutlined />
  if (trimmed.includes('hour')) return <ClockCircleOutlined />

  switch (name.toLowerCase()) {
    case 'experiment':
      return <ExperimentFilled />

    case 'column-width':
    case 'pay by mileage band':
      return <ColumnWidthOutlined />
    case 'field-time':
      return <ClockCircleOutlined />
    case 'warning':
      return <WarningFilled className='warning-icon' />
    case 'sick':
      return <img alt='' className='' src={SickFace} />
    default:
      return <ApartmentOutlined />
  }
}
